import React, { useState, useEffect } from "react";
import api from "../../lib/api";
import { Mail, Phone, Calendar, MessageSquare, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function AdminMessages() {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/contacts?limit=500");
        setMessages(data);
      } catch (e) {
        toast.error("Error al cargar mensajes");
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="space-y-5">
      <div>
        <h1 className="text-3xl font-bold text-slate-900">Mensajes recibidos</h1>
        <p className="text-slate-600 mt-1">{messages.length} mensajes del formulario de contacto</p>
      </div>

      {loading ? (
        <div className="p-12 text-center"><Loader2 className="animate-spin mx-auto text-cyan-600" /></div>
      ) : messages.length === 0 ? (
        <div className="bg-white rounded-2xl p-12 border border-slate-100 text-center text-slate-500">
          <MessageSquare className="mx-auto mb-3 text-slate-300" size={42} />
          <p>Aún no hay mensajes recibidos.</p>
        </div>
      ) : (
        <div className="space-y-3">
          {messages.map((m) => (
            <div key={m.id} className="bg-white rounded-2xl p-5 border border-slate-100 shadow-sm">
              <div className="flex items-start justify-between flex-wrap gap-2 mb-3">
                <div>
                  <div className="font-bold text-slate-900">{m.nombre}</div>
                  <div className="flex items-center gap-3 text-xs text-slate-500 mt-1 flex-wrap">
                    <a href={`mailto:${m.email}`} className="flex items-center gap-1 hover:text-cyan-700"><Mail size={12} /> {m.email}</a>
                    {m.telefono && <a href={`tel:${m.telefono}`} className="flex items-center gap-1 hover:text-cyan-700"><Phone size={12} /> {m.telefono}</a>}
                    <span className="flex items-center gap-1"><Calendar size={12} /> {new Date(m.created_at).toLocaleString("es-MX")}</span>
                  </div>
                </div>
                {m.asunto && <span className="bg-cyan-50 text-cyan-800 px-3 py-1 rounded-full text-xs font-medium">{m.asunto}</span>}
              </div>
              <p className="text-slate-700 leading-relaxed whitespace-pre-wrap">{m.mensaje}</p>
              <div className="mt-3 pt-3 border-t border-slate-100">
                <a href={`mailto:${m.email}?subject=Re: ${encodeURIComponent(m.asunto || "Tu consulta")}`} className="text-cyan-700 text-sm hover:underline font-medium">Responder →</a>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
